import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useConsumeMobileHandoffTokenMutation } from '../../../generated';
import { AUTH_TOKEN, LINKS } from '../../constants';
import { useAppContext } from '../../contexts/AppContext';

const MobileHandoff = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const redirect = searchParams.get('redirect');
  const shouldRunRef = useRef(true);
  const { setIsAppUserLoggedIn } = useAppContext();

  const [consumeToken] = useConsumeMobileHandoffTokenMutation({
    onCompleted(data: { consumeMobileHandoffToken?: { accessToken?: string | null } | null }) {
      const accessToken = data?.consumeMobileHandoffToken?.accessToken;
      if (accessToken) {
        sessionStorage.setItem(AUTH_TOKEN, accessToken);
        sessionStorage.setItem('fromMobile', 'true');
        setIsAppUserLoggedIn(true);
        navigate(redirect || LINKS.CHANGE_PLAN_LINK, { replace: true });
      } else {
        navigate(LINKS.LOGIN_LINK, { replace: true });
      }
    },
    onError() {
      navigate(LINKS.LOGIN_LINK, { replace: true });
    },
  });

  useEffect(() => {
    if (!shouldRunRef.current) return;
    shouldRunRef.current = false;
    localStorage.removeItem(AUTH_TOKEN);
    sessionStorage.removeItem(AUTH_TOKEN);
    sessionStorage.removeItem('fromMobile');
    if (token) {
      consumeToken({ variables: { token } });
    } else {
      navigate(LINKS.LOGIN_LINK, { replace: true });
    }
  }, []);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh" gap={2}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        Signing you in…
      </Typography>
    </Box>
  );
};

export default MobileHandoff;
